import React, { Component } from 'react'
import TextInput from './inputs/TextInput'
import SelectInput from './inputs/SelectInput'
import { cloneDeep, compose, map, reduce } from 'lodash/fp'

import {sendSoftware} from '../api/send'
import {changeFieldStatic} from '../utils/changeFieldStatic'
import {prepareState} from '../utils/prepareState'
import {emptyError} from '../utils/emptyError'

class Software extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: {
        id: 'name',
        value: '',
        error: false
      },
      inn: {
        id: 'inn',
        value: '',
        error: false
      },
      fullName: {
        id: 'fullName',
        value: '',
        error: false
      },
      email: {
        id: 'email',
        value: '',
        error: false
      },
      phone: {
        id: 'phone',
        value: '',
        error: false
      },
      software: {
        id: 'software',
        value: 'Dr Web',
        error: false
      },
      pcCount: {
        id: 'pcCount',
        value: '',
        error: false
      },
      plan: {
        id: 'plan',
        value: '',
        error: false
      },
      clientAccount: {
        id: 'clientAccount',
        value: '',
        error: false
      },
      bankAccount: {
        id: 'bankAccount',
        value: '',
        error: false
      },
      bik: {
        id: 'bik',
        value: '',
        error: false
      },
      bankName: {
        id: 'bankName',
        value: '',
        error: false
      }
    }

    this.changeField = this.changeField.bind(this)
    this.onSendForm = this.onSendForm.bind(this)
  }
  changeField(event) {
    changeFieldStatic.call(this, event)
  }
  onSendForm(event) {

    let {name, inn, fullName, email, phone, plan, clientAccount, bankAccount, bik, bankName, software, pcCount} = this.state
    if(name.value.trim() === '' || inn.value.trim() === '' || fullName.value.trim() === '' || email.value.trim() === '' || phone.value.trim() === '' || plan.value.trim() === '' || clientAccount.value.trim() === '' || bankAccount.value.trim() === '' || bik.value.trim() === '' || bankName.value.trim() === '' || software.value.trim() === '' || pcCount.value.trim() === '') {
      
      let newStateWithErrors = compose(reduce(prepareState, {}), map(emptyError))
      
      this.setState(function(prevState, props) {
        let oldState = cloneDeep(prevState)
        let newState = newStateWithErrors(oldState)
        return newState
      })
    }
    else {
      sendSoftware(this.state)
        .then(result => {
          this.props.history.push('/congrats')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
  render() {
    let {name, inn, fullName, email, phone, plan, clientAccount, bankAccount, bik, bankName, software, pcCount} = this.state
    let optionsFields = [];
    if(software.value === 'Dr Web') {
      optionsFields = [
        {label: 'Пожалуйста, выберите тариф', value: ''},
        {label: '12 мес', value: '12 мес'},
        {label: '24 мес', value: '24 мес'}
      ]
    }
    if(software.value === 'Windows') {
      optionsFields = [
        {label: 'Пожалуйста, выберите тариф', value: ''},
        {label: 'Windows 10', value: 'Windows 10'}, 
        {label: 'Windows 7', value: 'Windows 7'}
      ]
    }
    return (
      <div className="container">
        <div className="columns">
          <div className="column is-12 has-text-centered">
            <h1 className="title is-1">Антивирусы и Windows</h1>
          </div>
        </div>
        <div className="columns">
          <div className="column is-6 is-offset-3">
            <TextInput label="Наименование" placeholder="Наименование организации" dataId={name.id} value={name.value} onChange={this.changeField} error={name.error} />
            <TextInput label="ИНН" placeholder="ИНН организации" dataId={inn.id} value={inn.value} onChange={this.changeField} error={inn.error} />
            <TextInput label="Контактное лицо" placeholder="Контактное лицо" dataId={fullName.id} value={fullName.value} onChange={this.changeField} error={fullName.error}/>
            <TextInput label="Контактный email" placeholder="Контактный email" dataId={email.id} value={email.value} onChange={this.changeField} error={email.error} />
            <TextInput label="Контактный телефон" placeholder="Контактный телефон" dataId={phone.id} value={phone.value} onChange={this.changeField} error={phone.error} />
            <SelectInput label="Выберите программу" dataId={software.id} value={software.value} onChange={this.changeField} error={software.error}
              options={[{label: 'Dr Web', value: 'Dr Web'}, {label: 'Windows', value: 'Windows'}]}
            />
            <TextInput label="Количество компьютеров" placeholder="Количество компьютеров" dataId={pcCount.id} value={pcCount.value} onChange={this.changeField} error={pcCount.error} />
            <SelectInput label="Выберите тариф" dataId={plan.id} value={plan.value} onChange={this.changeField} error={plan.error}
              options={optionsFields}
            />
            <TextInput label="Расчетный счет" placeholder="Расчетный счет" dataId={clientAccount.id} value={clientAccount.value} onChange={this.changeField} error={clientAccount.error} />
            <TextInput label="Кор.Счет" placeholder="Кор.Счет" dataId={bankAccount.id} value={bankAccount.value} onChange={this.changeField} error={bankAccount.error} />
            <TextInput label="БИК" placeholder="БИК" dataId={bik.id} value={bik.value} onChange={this.changeField} error={bik.error} />
            <TextInput label="Наименование банка" placeholder="Наименование банка" dataId={bankName.id} value={bankName.value} onChange={this.changeField} error={bankName.error} />
            <div className="columns is-gapless">
              <div className="column is-4"></div>
              <div className="column is-7">
                <a className="button is-fullwidth is-large is-success" onClick={this.onSendForm}>Отправить</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Software


// WEBPACK FOOTER //
// ./src/components/Software.js